import { createFileRoute, redirect } from "@tanstack/react-router";
import { DefiPortfolioPage } from "../../features/defi/pages/defi-portfolio-page";

export const Route = createFileRoute("/_layout/defi/portfolio")({
  component: DefiPortfolioPage,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      protocolKey: search.protocolKey as string | undefined,
      position: search.position as string | undefined,
    };
  },
  beforeLoad: ({ search }) => {
    // If protocolKey is present, redirect to the same route without it
    if (search.protocolKey) {
      throw redirect({
        to: "/defi/portfolio/positions",
        search: {
          protocolKey: undefined,
          position: undefined,
        },
      });
    }
  },
});
